module.exports = __webpack_public_path__ + "static/media/13.bf9936c5.svg";